import React from "react";
import "./review-stars.scss";

export const ReviewStars: React.FC<{ rating: number }> = ({ rating }) => {
  return (
    <div className="c-review-stars ">
      <div className="c-review-stars__clip-container" style={{ width: `${(rating / 5) * 100}%` }}>
        <div className="c-review-stars__whole-stars">★★★★★</div>
      </div>
    </div>
  );
};
